module.exports = __webpack_public_path__ + "img/confetti_option_1.15b6a508.png";